<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>404 Error page</title>
</head>

<body>
    <div class="conf-missing-container">
        <div class="row">
            <div class="col-12 conf-column-missing">
                <div class="conf-col-parent-missing">
                    <img class="conf-missing-page-image" src="{{confAWSUrlStr}}/common/conf-error-404.webp"
                        alt="Page not found">
                </div>
                <p class="conf-big-missing-text">Oops! Page Not Found</p>
                <p class="conf-small-missing-text">This page doesn’t exist or was removed. We suggest you go back to homepage.</p>
                <p class="conf-small-missing-text conf-no-padding"></p>
                <div class="conf-button-missing-wrapper">
                    <button class="conf-back-to-home-btn" (click)="backToHome()">Back to Home</button>
                </div>
            </div>
        </div>
    </div>


</body>

</html>